"use strict";

exports.__esModule = true;
exports.getWixDataCategoryId = exports.getWixData = void 0;

var _lodash = require("lodash");

var _reselect = require("reselect");

var getWixData = function getWixData(state) {
  return state.wixData;
};

exports.getWixData = getWixData;
var getWixDataCategoryId = (0, _reselect.createSelector)([getWixData], function (wixData) {
  return (0, _lodash.get)(wixData, 'categoryId', null);
});
exports.getWixDataCategoryId = getWixDataCategoryId;